import React from 'react';

const pricingData = [
  {
    name: 'Software License',
    authorized: '20%',
    preferred: '35%',
    exclusive: '50%',
  },
  {
    name: 'Software Assurance',
    authorized: '20%',
    preferred: '35%',
    exclusive: '50%',
  },
  {
    name: 'Technical Support',
    authorized: '15%',
    preferred: '22%',
    exclusive: '30%',
  },
  {
    name: 'Professional Services',
    authorized: '10%',
    preferred: '16%',
    exclusive: '25%',
  },
];

export default function ProductPricing() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 bg-gray-100">
      <div className="col-span-1"></div>
      <div className="col-span-4 mx-auto py-14">
        <h1 className="text-4xl mb-4">Product Pricing and Discounts</h1>
        <p className="text-sm mb-6 mt-8 w-3/5">
          The table below shows the discount over recommended retail pricing for
          each tier of VAR.
        </p>

        <div className="overflow-x-auto">
          <table className="w-full table-fixed text-sm">
            <thead>
              <tr className="text-left text-[#BF984D] border-b border-gray-700">
                <th className="w-1/2"></th>
                <th className="w-2/4  text-center">Authorized VAR</th>
                <th className="w-2/4 text-center">Preferred VAR</th>
                <th className="w-2/4 text-center">Exclusive VAR</th>
              </tr>
            </thead>
            <tbody>
              {pricingData.map((item, index) => (
                <tr key={index} className="border-b border-gray-200">
                  <td className="py-3 text-lg font-medium text-[#BF984D]">
                    {item.name}
                  </td>
                  <td className="py-3 text-center">{item.authorized}</td>
                  <td className="py-3 text-center">{item.preferred}</td>
                  <td className="py-3 text-center">{item.exclusive}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-xs mt-4 text-gray-500 w-3/5 mb-10">
          *Please refer to the latest applicable Product Retail Pricing Plan for
          recommended retail pricing for Simplicity® software and services.
        </p>
      </div>
    </div>
  );
}
